import { Component, Input, ViewChild, forwardRef, Injector, AfterViewInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, NgControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';

import { Dictionary } from 'types';

import { Appearance } from '../types';

@Component({
    selector: 'fc-select',
    templateUrl: './fc-select.component.html',
    styleUrls: ['./fc-select.component.less'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FcSelectComponent),
            multi: true
        }
    ],
    standalone: false
})
export class FcSelectComponent implements ControlValueAccessor, AfterViewInit {
    @Input() placeholder: string;
    @Input() appearance: Appearance = Appearance.Standard;
    @Input() errorMessage: string;
    @Input() class: string;
    @Input() label = '';
    @Input() options: Array<Dictionary<any>>;
    @Input() disabled: boolean;
    @Input() dataE2eHook: string;
    @Input() errorE2eHook: string;
    @ViewChild(MatSelect, { static: true }) private matSelect: MatSelect;

    constructor(private injector: Injector) {}

    onChange = (_: any) => {};
    onTouched = () => {};

    ngAfterViewInit() {
        setTimeout(() => {
            this.matSelect.ngControl = this.injector.get(NgControl, null);
        });
    }

    writeValue(value: boolean): void {
        this.matSelect.value = value;
    }

    registerOnChange(fn: (_: any) => void): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    handleInput(value: boolean): void {
        this.onChange(value);
    }
}
